module.exports = "/_next/static/images/d02c4fb4e8e8abacb619ec12ec43dae6-two-people-looking-lg@3x.jpg.webp";